<mat-chip-grid aria-label="Fish selection" class="mt-tags">
  @for (chip of items; track chip) {
    <mat-chip [selectable]="selectable" [removable]="removable" (removed)="remove(chip)" [ngClass]="chip.type"
      >{{ chip.name }}
      <mat-icon matChipRemove>clear</mat-icon>
    </mat-chip>
  }
</mat-chip-grid>
